(function() {
    // 依赖引入 
    const Util = require('./Util.js') // 多种工具
    const Generate = require('./generateHtml.js') // 用于生成html代码 


    // 全局变量
    const agt = Util.getSearch().agt || 0; // 渠道
    const agt_link = agt ? '?agt=' + agt : ''
    const $content = $("#content")
    const $article = $("#article")


    // 全局配置
    // 1.内容区去掉阅读全文，增加翻页; 4 搜狗, 8 百度新闻,10 好123,35 鲜果渠道
    const global_pages = (agt == 8) || (agt == 10);
    // 2.右侧内容区底部固定
    const global_fixed = (agt == 8) || (agt == 10);
    // 3.娱乐+都市模块是否展示
    const global_hots = (agt == 8) || (agt == 35)

    const App = {

        id: window.global.id, // 文章id 
        type: window.global.type, // 文章类型  
        category: encodeURI(window.global.category), // 频道id
        searchKey: window.global.searchKey, //搜索关键字 

        aPage: window.global.aPage, // A页
        mediaPage: window.global.mediaPage, // ta页 
        tagPage: window.global.tagPage, // tag页
        isPure: window.global.isPure, // 判断是否是纯文章A页 0显示 1不显示 

        newsOffsetTop: 0,
        sideBarHeight: 0,
        // 接口地址定义
        api: {
            recomMenu: `/api/tag?`, // 推荐菜单
            recomFeed: `/api/feed?`, // 推荐阅读
            recomTagFeed: `/api/tag_feed?`, // tag 页推荐阅读
            recomMediaFeed: `/api/m/`, // ta 页推荐阅读
            hot: `/api/hot?`, // 热门推荐
            hots: `/api/hots?` // 热门推荐 
        },

        ajax: function(url, callback) {
            $.ajax({
                type: 'GET',
                url: url + '&' + 'agt=' + agt,
                dataType: 'jsonp',
                jsonp: 'callback',
                success: function(result) {
                    if (result.code == 200) {
                        if (result.data != '' && result.data != undefined) {
                            callback && callback(result.data);
                        } else {
                            $("#newsLoading").html("暂无数据");
                        }
                    } else {
                        $("#newsLoading").remove();
                    }
                }
            })
        },

        article: {
            init: function() {
                this.video();
                this.uninterestedBoxEvent();

                // 非领导人模板
                if (!App.isPure) {
                    // global_pages 配置项
                    if (!global_pages) { this.more() }
                }
            },
            video: function() {
                let newDiv = document.getElementById("article");
                let videos = [].slice.call(newDiv.querySelectorAll('video'));
                videos.map(function(video, index) {
                    if (video.dataset.source) {
                        //平台内视频
                        video.src = video.dataset.source;
                        video.setAttribute("controls", "controls");
                        if (video.dataset.desc) {
                            video.insertAdjacentHTML('afterend', '<p class="video-description">' + video.dataset.desc + '</p>');
                        }
                    } else {
                        //外域视频
                        if (video.dataset.src) {
                            let vvv = decodeURIComponent(video.dataset.src)
                            $.ajax({
                                type: 'GET',
                                url: '/api/video?url=' + encodeURIComponent(vvv),
                                beforeSend: function(request) {
                                    request.setRequestHeader("Accept", 'application/vnd.hq_time.v1+jsonP');
                                    request.setRequestHeader("ClientVersion", 'v1.13');
                                },
                                processData: false,
                                success: function(msg) {

                                    if (msg.status != 'fail') {
                                        video.insertAdjacentHTML('beforebegin', '<div class="frame-wrapper">' + decodeURIComponent(msg) + '</div>'); //播放代码,iframe嵌套的播放器

                                        if (video.dataset.desc && video.dataset.desc != undefined) {
                                            video.insertAdjacentHTML('afterend', '<p class="video-description">' + video.dataset.desc + '</p>'); //描述信息
                                        }
                                        video.parentNode.removeChild(video);
                                    } else {
                                        video.insertAdjacentHTML('beforebegin', '<div class="frame-wrapper">' + decodeURIComponent(msg.data) + '</div>'); //播放代码,iframe嵌套的播放器
                                    }
                                },
                                error: function(msg) {
                                    // console.error(msg);
                                }
                            });
                        }
                    }
                });
            },
            more: function() {
                let $articleCon = $article.find(".a-con");
                if ($articleCon.height() >= 700) {
                    $articleCon.css('height', 700);

                    let moreHTML = `<a href="javascript:void(0);" id="more">阅读全文<i class="iconfont icon-xiangxia-copy"></i></a>`
                    $articleCon.append(moreHTML);

                    $("#more").on("click", function() {
                        $articleCon.css({ 'height': 'auto' });
                        $(this).remove();

                        App.newsOffsetTop = $content.find("#news").offset().top
                    })
                }
            },
            uninterestedBoxEvent: function() {

                let $uninterested = $("#uninterested");
                let $uninterestedBox = $(".uninterested-box");
                let $other = $uninterested.find('li[data-val=10]');



                $uninterested.find('a').on("click", function() {

                    let isClick = $(this).attr('data-click');

                    if (isClick == "1") {
                        $(this).attr('data-click', 0)
                        $uninterestedBox.hide();
                    } else {
                        $(this).attr('data-click', 1)
                        $uninterestedBox.show();
                    }

                });

                $uninterestedBox.find("li").on("click", function() {

                    let isSelected = $(this).attr("class");
                    if (isSelected) {
                        $(this).removeClass('selected');
                        // 其他问题
                        $(this).attr('data-val') == '10' ? $uninterestedBox.find(".otherarea").hide() : '';
                    } else {
                        $uninterested.find('.info').hide();
                        $(this).addClass('selected');
                        // 其他问题
                        $(this).attr('data-val') == '10' ? $uninterestedBox.find(".otherarea").show() : '';
                    }

                })

                $uninterestedBox.find(".btn").on("click", function() {

                    if (!$uninterested.find('.selected').length || ($other.attr("class") == "selected" && $uninterestedBox.find(".otherarea").val() == '')) {
                        $uninterested.find('.info').show();
                        return false;
                    }

                    let $unfeedback = $uninterested.find('.unfeedback');

                    $uninterested.find('a').attr('data-click', 0);
                    $uninterestedBox.hide();

                    $unfeedback.show();
                    setTimeout(function() {
                        $unfeedback.hide();
                    }, 3000);
                })
            }
        },

        sideBar: {
            init: function() {
                App.sideBar.search()
                App.sideBar.hot()

                if (global_hots) {
                    App.sideBar.hots()
                }
            },
            search: function() {

                let $search = $("#search");
                let str = `
                <input type="text" class="s-txt" placeholder="大家都在说：${App.searchKey}">
                <a href="javascript:void(0)" target="_blank" class="s-btn"><i class="iconfont icon-sousuo"></i></a>'
                `
                $search.html(str);
                $search.find(".s-btn").on("click", function() {
                    let sv = $search.find(".s-txt").val() || App.searchKey;
                    window.open(`https://www.baidu.com/s?wd=site:www.huanqiu.com${sv}`);
                })
            },
            hot: function() {
                let $sideBar = $("#sideBar")
                App.ajax(App.api.hot, function(data) {
                    let news = data.news
                    let picture = data.picture
                    let recommend = data.recommend

                    // 需要在数据列表中插入广告，单独一条返回
                    for (let n in picture) {
                        if (n < 1) {
                            $sideBar.find("#hotPics ul").prepend(Generate.hotPictureHtml(picture[n], 'large'))
                        } else if (n < 3) {
                            $sideBar.find("#hotPics ul").append(Generate.hotPictureHtml(picture[n]))
                        }
                    }
                    Util.setImgUrl($("#hotPics"))
                    $sideBar.find("#hotNews").html(Generate.hotHtml(news))
                    Util.setImgUrl($("#hotNews"))
                    $sideBar.find("#hotLists").html(Generate.hotRecommendHtml(recommend))
                    Util.setImgUrl($("#hotLists"))
                })
            },
            hots: function() {
                let $sideBar = $("#sideBar")
                App.ajax(App.api.hots, function(data) {
                    let city = data.dushi
                    let ent = data.yule

                    $sideBar.find("#hotsCity").html(Generate.hotsCityHtml(city))
                    Util.setImgUrl($("#hotsCity"))
                    $sideBar.find("#hotsEnt").html(Generate.hotsEntHtml(ent))
                    Util.setImgUrl($("#hotsEnt"))
                })
            }
        },

        recommend: {
            init: function() {
                function html(callback) {
                    var str = `<div class="content-c" id="newsWraper">`
                    if (App.aPage) {
                        str += `  
                        <h2 class="title"><strong>推荐阅读</strong></h2>
                        <div class="c-menu" id="newsMenu"></div>`
                    } else if (App.tagPage) {
                        str += `<div class="c-menu c-menu-fixed" id="newsMenu"></div>`
                    } else if (App.mediaPage) {
                        str += `  
                        <h2 class="title"><strong>全部文章</strong></h2>`
                    }
                    str += `
                      <div class="bd">
                        <div class="news-wrapper" id="news"></div>
                        <div id="newsLoading"><i class="iconfont icon-loading1"></i> 加载更多.. </div>
                      </div>
                    </div>`
                    return str;
                }

                $content.append(html())
                App.newsOffsetTop = $content.find("#news").offset().top

                this.menu()
                this.news()

            },
            menu: function() {
                const $newsMenu = $content.find("#newsMenu");

                App.ajax(App.api.recomMenu, (data) => {
                    const tags = data.tags;
                    let str = '<ul>'
                    let selected = '';
                    str += App.aPage ? `<li class="selected"><a href="#newsWraper">推荐</a></li>` : ''
                    for (let i = 0; i < tags.length; i++) {
                        selected = (window.global.id == tags[i].code) ? 'class="selected"' : ''
                        str += ` <li ${selected}><a href="/tag/${tags[i].code}${agt_link}" target="_blank">${tags[i].name}</a></li>`
                    }
                    str += '</ul>'

                    $newsMenu.html(str);
                    // $newsMenu.find("li").on("click", function() {
                    //     $(this).addClass('selected').siblings().removeClass('selected');
                    // });
                });
            },
            news: function() {
                App.recommend.tmp.loading = true
                const $news = $content.find("#news");
                let url = '';
                if (App.aPage) {
                    url = App.recommend.url + 'category=' + App.category + '&page=' + App.recommend.tmp.page
                } else if (App.tagPage) {
                    url = App.recommend.url + 'code=' + App.id + '&page=' + App.recommend.tmp.page

                } else if (App.mediaPage) {
                    url = App.recommend.url + App.id + '?page=' + App.recommend.tmp.page
                }


                App.ajax(url, (result) => {
                    const data = result;
                    for (let n in data) {
                        if (data[n].ad) {
                            if (App.recommend.tmp.ad.length < 20) { // 手动控制加载小于20条广告 
                                $news.append(`<div class="aa-item"></div>`);
                                App.recommend.tmp.ad.push(data[n])
                            }
                        } else {
                            $news.append(Generate.newsHtml(data[n]));
                            Util.setImgUrl($news)
                        }
                    }

                    // 广告
                    App.recommend.ad()

                    App.recommend.tmp.loading = false
                    App.recommend.tmp.page++
                });

            },
            tmp: {
                'ad': [],
                'ad_count': 0,
                'ad_count_feed': 0,
                'ad_count_peng': 0,
                'page': 1,
                'loading': false
            },
            ad: function() {

                let ad = App.recommend.tmp.ad,
                    num = 0
                let container = document.querySelector("div#news")
                setInterval(function() {
                    if (num > 50) return false
                    let ads = container.querySelectorAll(".aa-item");

                    for (let i = 0; i < ads.length; i++) {

                        let adEle = ads[i];

                        if (adEle.querySelector("iframe") || adEle.querySelector("div")) continue;
                        if (adEle.childElementCount) break;


                        // 仙果渠道合作方投放广告只调用对方方法
                        if (agt == 35 && App.aPage) {
                            num = App.recommend.tmp.ad_count++;
                            $(adEle).attr('id', 'aa_feed_' + ad[i]._id + '_' + num)
                            window._m0Ew4KQB_.f()
                            break
                        }
                        // feed 360 广告
                        else if (ad[i].code.indexOf('feed') >= 0 || ad[i]._id.indexOf('feed') >= 0) {
                            num = App.recommend.tmp.ad_count_feed++;
                            $(adEle).attr('id', 'aa_feed_' + ad[i]._id + '_' + num).append(ad[i].code)
                        }
                        // 百度 广告
                        else if (ad[i]._id.indexOf('u') >= 0) {
                            if (ad[i].repeat) { num = App.recommend.tmp.ad_count++; } else { num = 0 }
                            $(adEle).attr('id', 'BAIDU_SSP__wrapper_' + ad[i]._id + '_' + num).append(ad[i].code)
                        }
                        // 鹏泰广告
                        else {
                            if (ad[i].repeat) { num = App.recommend.tmp.ad_count_peng++; } else { num = 0 }
                            $(adEle).attr('id', 'AD_SURVEY_POSITION_SIMPLE_' + ad[i]._id + '_' + num).append('<script type="text/javascript">window.AD_SURVEY_Add_AdPos_Simple && AD_SURVEY_Add_AdPos_Simple("' + ad[i]._id + '");</script>')
                        }
                        break
                    }
                }, 400);
            }
        },
        scroll: function() {
            let docHeight = $(document).height(); //页面高度
            let winHeight = $(window).height(); //窗口可视高度
            let winScrollTop = $(window).scrollTop(); //滚动高度   

            if (App.aPage) {
                // 推荐阅读滚动&固定
                (App.newsOffsetTop - winScrollTop) <= 100 ? $("#newsMenu").addClass('c-menu-fixed') : $("#newsMenu").removeClass('c-menu-fixed');
                (App.newsOffsetTop - winScrollTop) <= 600 ? $article.find('.m-column').removeClass('column-fixed') : $article.find('.m-column').addClass('column-fixed');
            }
            //
            if (!App.isPure) {

                App.sideBarHeight = Math.max(App.sideBarHeight, $('#sideBar').outerHeight());

                // // 右侧内容底部固定
                if (global_fixed) {
                    if (App.sideBarHeight - winScrollTop - winHeight + 70 <= 0) {

                        $('#sideBar').find(".side-bar-con").css({ "position": "fixed", "bottom": 0 })

                    } else {
                        $('#sideBar').find(".side-bar-con").removeAttr('style');
                    }
                }
                // 默认右侧热点新闻(.s-b)固定
                else {
                    if (App.sideBarHeight - winScrollTop <= 0) {
                        $('#sideBar').find(".s-b").addClass('s-fixed')
                    } else {
                        $('#sideBar').find(".s-b").removeClass('s-fixed');
                    }
                }

                // 推荐阅读加载
                if ((docHeight - winHeight - winScrollTop) <= 2000) {
                    if (!App.recommend.tmp.loading) {
                        if (App.recommend.tmp.page <= 25) {
                            App.recommend.news();
                        } else {
                            $("#newsLoading").html("没有内容了~")
                        }
                    }
                }
            }

        },
        init: function() {

            let load = false

            // 详情页
            if (this.aPage) {
                this.article.init()
                this.sideBar.init()
                this.recommend.url = App.api.recomFeed;
                this.recommend.init();

                load = true
            }

            // tag 页
            if (this.tagPage) {
                this.sideBar.init()
                this.recommend.url = App.api.recomTagFeed;
                this.recommend.init();

                load = true
            }

            // media 页
            if (this.mediaPage) {
                this.sideBar.init()
                this.recommend.url = App.api.recomMediaFeed;
                this.recommend.init();

                load = true
            }


            load && $(window).on("scroll", function() {
                App.scroll();
            });
        }
    }
    App.init()
})()


// WEBPACK FOOTER //
// ./src/js/index_release.js